import {Component, OnInit, Input} from '@angular/core';
import {
  FormGroup
} from '@angular/forms';
import {RequestDataService} from './../../service/request-data.service';

@Component({
  selector: 'app-select-multi',
  templateUrl: './select-multi.component.html',
  styleUrls: ['./select-multi.component.css']
})
export class SelectMultiComponent implements OnInit {

  @Input() hulkForm: FormGroup;
  @Input() hulkColumn: any;

  // 改变绑定对象
  @Input() bindModel: any;

  constructor(private requestDataService: RequestDataService) {
  }


  modelChange(model) {
    if (this.bindModel) {
      this.bindModel[this.hulkColumn.column] = model;
    } else {
      this.hulkColumn.model = model;
    }
  }


  ngOnInit() {
    this.hulkColumn.nzMode = this.hulkColumn.nzMode || 'multiple';
    this.hulkColumn.lableSpan = this.hulkColumn.lableSpan || 9;
    this.hulkColumn.itemSpan = this.hulkColumn.itemSpan || 15;
    this.hulkColumn.limitLength = this.hulkColumn.limitLength || 99999999;
    if (!this.hulkColumn.itemArray && this.hulkColumn.dictionary) {
      this.requestDataService.getDataByCondition(this.hulkColumn.dictionary).subscribe(result => {
        this.hulkColumn.itemArray = result['data'] || [];
      });
    }
    if (this.bindModel && this.bindModel[this.hulkColumn.column] === '') {
      this.bindModel[this.hulkColumn.column] = null;
    }
  }

}
